<template>
  <div id="wxframe" class="text-center m-t-10"></div>
</template>

<script>
export default {
  name: 'wxlogin',
  mounted () {
    window.WwLogin({
      id: 'wxframe',
      appid: 'ww06b701cf54b21c98',
      agentid: '1000008',
      scope: 'snsapi_login',
      redirect_uri: 'http://www.oohforce.com', // 转到当前地址以获取code值
      state: Math.random(),
      href: ''
    })
  }
}
</script>
